<!-- eslint-disable vue/max-attributes-per-line -->
<template>
    <List :data="list" :has-more="hasMore" :empty-content="emptyContent" @load-more="handleLoadMore" />
</template>

<script >
import { computed, onMounted, ref } from 'vue-demi';
import { PAGE_SIZE } from '../assets/scripts/constants';
import request from '../assets/scripts/request';
import List from '../components/List.vue';
const __sfc_main = {};
__sfc_main.props = {
  actSign: {
    type: String,
    default: ''
  },
  module: {
    type: String,
    default: ''
  },
  isPreviewEmpty: {
    type: Boolean,
    default: false
  },
  emptyContent: {
    type: String,
    default: ''
  },
  defaultStatusContent: {
    type: String,
    default: ''
  },
  statusList: {
    type: Array,
    default: () => []
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useToast
  } = require('@fegobull/webapi').use;
  const Toast = useToast();
  const props = __props;
  const hasMore = ref(false);
  const list = ref([]);
  const page = ref(1);
  const statusContents = computed(() => {
    return props.statusList.map(item => {
      return {
        actionIds: item.actionIds.split(',').map(Number),
        content: item.content
      };
    });
  });

  // 根据 actionIds 获取状态内容
  const getStatusContent = item => {
    // 如果actionIds为空，则返回默认状态内容
    if (item.actionIds.length === 0) {
      return props.defaultStatusContent || '';
    }
    // 遍历状态配置，找到第一个符合条件的返回展示内容
    for (const statusItem of statusContents.value) {
      if (statusItem.actionIds.every(id => item.actionIds.includes(id))) {
        return statusItem.content;
      }
    }
    return props.defaultStatusContent || '';
  };
  const getList = async () => {
    try {
      Toast.loading();
      const params = {
        actSign: props.actSign,
        module: props.module,
        page: page.value,
        pageSize: PAGE_SIZE
      };
      const res = await request.getFissionList(params);
      const reslist = res.list.map(item => {
        return {
          ...item,
          content: getStatusContent(item)
        };
      });
      hasMore.value = res.page * res.pageSize < res.total;
      if (hasMore.value) {
        page.value += 1;
      }
      list.value = [...list.value, ...reslist];
    } catch (error) {
      console.error('加载数据失败:', error);
    } finally {
      // 关闭 loading
      Toast.close();
    }
  };
  const handleLoadMore = async callback => {
    if (!hasMore.value) {
      callback?.();
      return;
    }
    await getList();
    // 通知 List 组件加载完成
    callback?.();
  };
  onMounted(() => {
    getList();
  });
  return {
    hasMore,
    list,
    handleLoadMore
  };
};
__sfc_main.components = Object.assign({
  List
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="less" scoped></style>
